// The body of a screen (um/2026-10-30/03 п.10, um/2026-10-30/04 п.3, DESIGN.md «Ширина контента»): the top line of the app with the
// page's name and actions, then one container with two widths — a single page (the settings, a pipeline) of a fixed width centred,
// a collection (the cards of scenarios) over the whole width — the same paddings and blocks on every screen.

import type { ReactNode } from 'react';
import { cx } from './primitives.tsx';
import { TopBar, TopTitle, type TopAction } from './TopBar.tsx';
import s from './page.module.css';

export function Page({ width = 'single', title, icon, note, sub, actions, end, children, className }: {
  /** `full` — the body is a screen of its own under the top line (a list and the reading column), without paddings. */
  width?: 'single' | 'collection' | 'full'; title?: ReactNode; icon?: string;
  /** A short note after the name in the top line (a count). */
  note?: ReactNode;
  /** A line that explains the page: the first line of the body. */
  sub?: ReactNode;
  actions?: TopAction[]; end?: ReactNode; children: ReactNode; className?: string;
}) {
  return (
    <div className={s.frame}>
      {(title || actions || end) && <TopBar start={title && <TopTitle icon={icon} note={note}>{title}</TopTitle>} actions={actions} end={end} />}
      <div className={cx(s.page, width === 'collection' && s.collection, width === 'full' && s.full)}>
        <div className={cx(s.inner, className)}>
          {sub && <p className={s.sub}>{sub}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}

/** The single width of a page for a screen with a head of its own (the record's page): the same width, centring and paddings. */
export const singleClass = s.single;

/**
 * A block of a page: a heading, an optional line under it and the content — the same frame for every group of settings.
 * `rows` — the content is rows of settings with a line between them (DESIGN.md «Настройки»); `tone="danger"` — the danger
 * zone, the last block of a page with what cannot be undone, its frame and heading in the danger colour.
 */
export function PageBlock({ title, help, rows, tone, label, children }: {
  title?: ReactNode; help?: ReactNode; rows?: boolean; tone?: 'danger'; label?: string; children: ReactNode;
}) {
  return (
    <section className={cx(s.block, tone === 'danger' && s.blockDanger)} aria-label={label}>
      {title && <h2 className={s.blockTitle}>{title}</h2>}
      {help && <p className={s.sub}>{help}</p>}
      <div className={cx(s.blockBody, rows && s.blockRows)}>{children}</div>
    </section>
  );
}
